import { render, staticRenderFns } from "./FormTask.vue?vue&type=template&id=0c1c7652&scoped=true&"
import script from "./FormTask.vue?vue&type=script&lang=js&"
export * from "./FormTask.vue?vue&type=script&lang=js&"
import style0 from "./FormTask.vue?vue&type=style&index=0&id=0c1c7652&prod&lang=scss&scoped=true&"
import style1 from "./FormTask.vue?vue&type=style&index=1&id=0c1c7652&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c7652",
  null
  
)

export default component.exports